__turbopack_context__.v({
  "column": "BlockHeroTwoColumn-module-scss-module__iVXF4a__column",
  "columnInner": "BlockHeroTwoColumn-module-scss-module__iVXF4a__columnInner",
  "flushTop": "BlockHeroTwoColumn-module-scss-module__iVXF4a__flushTop",
  "hasRichHeadline": "BlockHeroTwoColumn-module-scss-module__iVXF4a__hasRichHeadline",
  "holidayBlue": "BlockHeroTwoColumn-module-scss-module__iVXF4a__holidayBlue",
  "holidayRust": "BlockHeroTwoColumn-module-scss-module__iVXF4a__holidayRust",
  "holidaySquash": "BlockHeroTwoColumn-module-scss-module__iVXF4a__holidaySquash",
  "inner": "BlockHeroTwoColumn-module-scss-module__iVXF4a__inner",
  "lockup": "BlockHeroTwoColumn-module-scss-module__iVXF4a__lockup",
  "reversed": "BlockHeroTwoColumn-module-scss-module__iVXF4a__reversed",
  "root": "BlockHeroTwoColumn-module-scss-module__iVXF4a__root",
  "tillamookBlue": "BlockHeroTwoColumn-module-scss-module__iVXF4a__tillamookBlue",
});
